export default "__VITE_ASSET__9zaofwHK__"